App.namespace('es6.views.login.facebookAuth', function () {
  function loadFacebookSDK() {
    // already loaded
    if (window.FB || window.loadFacebookSDKRequested) {
      return;
    }

    window.loadFacebookSDK();
  }

  function trigger({ url, token, trackingParams }) {
    return new Promise((resolve) => {
      const callback = ({ status, authResponse }) => {
        if (status !== 'connected') {
          throw new Error('Error when logging in with facebook.');
        }

        $.ajax({
          url: url,
          type: 'POST',
          data: {
            token: authResponse.accessToken,
            _token: token,
            trackingParams
          },
          success: (response) => {
            resolve({ isSuccess: true, ...response });
          },
          error: (jqXHR) => {
            resolve({
              isSuccess: false,
              refusalMessage: App.es6.shared.social_login_error.getRefusalMessage(jqXHR),
            });
          },
        });
      };

      const options = {
        scope: 'email',
        return_scopes: true,
        auth_type: 'rerequest',
      };
      window.FB.login(callback, options);
    });
  }

  return {
    loadFacebookSDK,
    trigger,
  };
});
